<div class="dialog" data-testid="confirm-modal">
  <div class="title-container">
    <div class="title-left">
      <mat-icon class="icon-title" *ngIf="data.titleIcon">
        {{ data.titleIcon }}
      </mat-icon>
      <h3 class="title" data-testid="confirm-modal-title">{{ (data.title || "Are you sure?" )| translate }}</h3>
    </div>
    <button *ngIf="!data?.hideCloseBtn" class="close-btn" (click)="onCancel()" mat-icon-button data-testid="confirm-modal-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="desc" data-testid="confirm-modal-message">
    {{ (data.message || "Are you sure you want to do this?") | translate }}
  </div>
  <div class="actions">
    <button
      class="def-button confirm-btn"
      color="primary"
      (click)="onConfirm()"
      data-testid="confirm-modal-accept"
    >
      {{ (data.confirmText || "Yes") | translate }}
    </button>
    <button *ngIf="!data?.hideCancelBtn" class="def-button cancel-btn" (click)="onDismiss()" data-testid="confirm-modal-cancel">
      {{ (data.cancelButton || "No") | translate }}
    </button>
  </div>
</div>
